@if (loanBannerMessages().length) {
  <div>
    @for (message of loanBannerMessages(); track message.summary) {
      <p-message [closable]="false" class="loan-banner-message" [severity]="message.severity" icon="pi pi-exclamation-triangle">
        <span [innerHTML]="message.detail"></span>
      </p-message>
    }
  </div>
}
@if (showNavbar$ | async) {
  <cmg-clear2-ui-navbar (logoutClicked)="logout()" />
}
<p-toast position="top-right" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="d-flex flex-column flex-grow-1">
      <div class="p-toast-message-text">
        @if (message.summary) {
          <div class="p-toast-summary">{{ message.summary }}</div>
        }
        @if (message.detail) {
          <div class="p-toast-detail" [innerHTML]="message.detail | safeHtml"></div>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
<router-outlet />
@if (isLoading$ | async) {
  <cmg-clear2-ui-busy-indicator [loadingMessage]="loadingMessage$ | async" [zIndex]="zIndexSpinner$ | async" />
}
